export const Moves: {[k: string]: ModdedMoveData} = {
	doubleironbash: {
		inherit: true,
		isNonstandard: null,
		gen: 1,
	},
	thousandarrows: {
		inherit: true,
		isNonstandard: null,
		gen: 1,
	},
	thousandwaves: {
		inherit: true,
		isNonstandard: null,
		gen: 1,
	},
};
